import { render, staticRenderFns } from "./testDisplayItem.vue?vue&type=template&id=23a2878c&scoped=true"
import script from "./testDisplayItem.vue?vue&type=script&lang=js"
export * from "./testDisplayItem.vue?vue&type=script&lang=js"
import style0 from "./testDisplayItem.vue?vue&type=style&index=0&id=23a2878c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a2878c",
  null
  
)

export default component.exports